module.exports = __webpack_public_path__ + "static/media/180716_Griffith_Giulia_073-edit.b0198d7d.jpg";